import { Component, inject, OnInit } from '@angular/core';
import { map, Observable, of, switchMap, take } from 'rxjs';
import { SavedDatabaseModel } from '../../../models/saved/saved-database-model.type';
import { AsyncPipe } from '@angular/common';
import { ButtonComponent } from '../../../../../core/components/button/component/button.component';
import { DatabaseModelApiService } from '../../../services/database-model-api/database-model-api.service';
import { DatabaseModelService } from '../../../services/database-model/database-model.service';
import { DatabaseModel } from '../../../models/class/database-model.class';
import { AuthApiService } from '../../../../../core/services/auth/auth-api.service';
import { TrashComponent } from '../../../../../core//components/svg/trash/trash.component';
import { UserCredentials } from '../../../../../core/model/user/userCredentials';

@Component({
  selector: 'app-database-model-menu-page',
  standalone: true,
  imports: [AsyncPipe, ButtonComponent, TrashComponent, TrashComponent],
  templateUrl: './database-model-menu-page.component.html',
  styleUrl: './database-model-menu-page.component.scss',
})
export class DatabaseModelMenuPageComponent implements OnInit {
  private _api: DatabaseModelApiService = inject(DatabaseModelApiService);
  private _authService: AuthApiService = inject(AuthApiService);
  model$: Observable<DatabaseModel> = inject(DatabaseModelService).getModel$();
  allModels$: Observable<SavedDatabaseModel[] | undefined> = this.getAllModels$();

  modelIsEmpty$: Observable<boolean> = new Observable<boolean>();

  ngOnInit(): void {
    this.modelIsEmpty$ = this.model$.pipe(map(model => model.isEmpty()));
  }

  getAllModels$(): Observable<SavedDatabaseModel[] | undefined> {
    return this._authService.getUser$().pipe(
      map((user: Pick<UserCredentials, 'email'> | null | undefined): boolean => {
        if (user === null || user === undefined) return false;
        return true;
      }),
      switchMap((isUserConnected: boolean) => {
        if (isUserConnected) {
          return this._api.getAllDatabaseModels$();
        }
        return of(undefined);
      })
    );
  }

  delete(id: number): void {
    this._api.deleteDatabaseModel$(id).pipe(
      take(1)
    )
      .subscribe(
        (models: SavedDatabaseModel[] | undefined) => {
          this.allModels$ = of(models);
        }
      );
  }
}
